// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TermsOfUseIndexRouteImport } from './routes/terms-of-use/index'
import { Route as StatisticsIndexRouteImport } from './routes/statistics/index'
import { Route as PrivacyPolicyIndexRouteImport } from './routes/privacy-policy/index'
import { Route as ItemsIndexRouteImport } from './routes/items/index'
import { Route as FaqIndexRouteImport } from './routes/faq/index'
import { Route as ExtensionIndexRouteImport } from './routes/extension/index'
import { Route as ContactIndexRouteImport } from './routes/contact/index'
import { Route as AccessibilityIndexRouteImport } from './routes/accessibility/index'
import { Route as EmbedUinRouteImport } from './routes/embed/$uin'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as ItemUinIndexRouteImport } from './routes/item/$uin/index'
import { Route as ItemUinNameRouteImport } from './routes/item/$uin/$name'
import { Route as PublicAuthVerifyRouteImport } from './routes/_public/auth/verify'
import { Route as AuthedProfileIndexRouteImport } from './routes/_authed/profile/index'
import { Route as AuthedHelpIndexRouteImport } from './routes/_authed/help/index'
import { Route as AuthedAccountIndexRouteImport } from './routes/_authed/account/index'

const PublicRoute = PublicRouteImport.update({
            id: '/_public',getParentRoute: () => rootRouteImport
          })
const AuthedRoute = AuthedRouteImport.update({
            id: '/_authed',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const TermsOfUseIndexRoute = TermsOfUseIndexRouteImport.update({
            id: '/terms-of-use/',path: '/terms-of-use/',getParentRoute: () => rootRouteImport
          })
const StatisticsIndexRoute = StatisticsIndexRouteImport.update({
            id: '/statistics/',path: '/statistics/',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyIndexRoute = PrivacyPolicyIndexRouteImport.update({
            id: '/privacy-policy/',path: '/privacy-policy/',getParentRoute: () => rootRouteImport
          })
const ItemsIndexRoute = ItemsIndexRouteImport.update({
            id: '/items/',path: '/items/',getParentRoute: () => rootRouteImport
          })
const FaqIndexRoute = FaqIndexRouteImport.update({
            id: '/faq/',path: '/faq/',getParentRoute: () => rootRouteImport
          })
const ExtensionIndexRoute = ExtensionIndexRouteImport.update({
            id: '/extension/',path: '/extension/',getParentRoute: () => rootRouteImport
          })
const ContactIndexRoute = ContactIndexRouteImport.update({
            id: '/contact/',path: '/contact/',getParentRoute: () => rootRouteImport
          })
const AccessibilityIndexRoute = AccessibilityIndexRouteImport.update({
            id: '/accessibility/',path: '/accessibility/',getParentRoute: () => rootRouteImport
          })
const EmbedUinRoute = EmbedUinRouteImport.update({
            id: '/embed/$uin',path: '/embed/$uin',getParentRoute: () => rootRouteImport
          })
const PublicLoginRoute = PublicLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => PublicRoute
          })
const ItemUinIndexRoute = ItemUinIndexRouteImport.update({
            id: '/item/$uin/',path: '/item/$uin/',getParentRoute: () => rootRouteImport
          })
const ItemUinNameRoute = ItemUinNameRouteImport.update({
            id: '/item/$uin/$name',path: '/item/$uin/$name',getParentRoute: () => rootRouteImport
          })
const PublicAuthVerifyRoute = PublicAuthVerifyRouteImport.update({
            id: '/auth/verify',path: '/auth/verify',getParentRoute: () => PublicRoute
          })
const AuthedProfileIndexRoute = AuthedProfileIndexRouteImport.update({
            id: '/profile/',path: '/profile/',getParentRoute: () => AuthedRoute
          })
const AuthedHelpIndexRoute = AuthedHelpIndexRouteImport.update({
            id: '/help/',path: '/help/',getParentRoute: () => AuthedRoute
          })
const AuthedAccountIndexRoute = AuthedAccountIndexRouteImport.update({
            id: '/account/',path: '/account/',getParentRoute: () => AuthedRoute
          })





const AuthedRouteChildren = {
  AuthedAccountIndexRoute: AuthedAccountIndexRoute,AuthedHelpIndexRoute: AuthedHelpIndexRoute,AuthedProfileIndexRoute: AuthedProfileIndexRoute
}

const AuthedRouteWithChildren = AuthedRoute._addFileChildren(AuthedRouteChildren)




const PublicRouteChildren = {
  PublicLoginRoute: PublicLoginRoute,PublicAuthVerifyRoute: PublicAuthVerifyRoute
}

const PublicRouteWithChildren = PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthedRoute: AuthedRouteWithChildren,PublicRoute: PublicRouteWithChildren,EmbedUinRoute: EmbedUinRoute,AccessibilityIndexRoute: AccessibilityIndexRoute,ContactIndexRoute: ContactIndexRoute,ExtensionIndexRoute: ExtensionIndexRoute,FaqIndexRoute: FaqIndexRoute,ItemsIndexRoute: ItemsIndexRoute,PrivacyPolicyIndexRoute: PrivacyPolicyIndexRoute,StatisticsIndexRoute: StatisticsIndexRoute,TermsOfUseIndexRoute: TermsOfUseIndexRoute,ItemUinNameRoute: ItemUinNameRoute,ItemUinIndexRoute: ItemUinIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)